/**
 * 计量单位的接口api
 * date:2022 03 08
 */
 import httpRequest from '@/utils/request.js';

  /**查询分页 */
  export const probeUnitPage = (params = {}) => httpRequest.httpGet({
    url: '/service/probeUnit/page', params: {
      ...params
    }
  })
  /**查询详情 */
  export const probeUnitDetail = (params = {}) => httpRequest.httpGet({
    url: '/service/probeUnit/detail', params: {
      ...params
    }
  })

  /**新增保存 */
  export const probeUnitAdd = (data, loadingOptions) => httpRequest.httpPost('/service/probeUnit/add', data, loadingOptions)

  /**修改 */
  export const probeUnitEdit = (data, loadingOptions) => httpRequest.httpPut('/service/probeUnit/update', data, loadingOptions)
  
  /**删除 */
  export const probeUnitDelete = (data, loadingOptions) => httpRequest.httpdelete('/service/probeUnit/del', data, loadingOptions);

  // /** 校验唯一性 */
  // export const monitorRangeCheck = (data, loadingOptions) => httpRequest.httpPost('/service/monitorRange/check', data, loadingOptions)


